
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface UseAnnouncementListingsProps {
  announcementId: string;
}

export const useAnnouncementListings = ({ announcementId }: UseAnnouncementListingsProps) => {
  return useQuery({
    queryKey: ['announcement-listings', announcementId],
    queryFn: async () => {
      // First get the listings for this announcement
      const { data: listings, error: listingsError } = await supabase
        .from('listings')
        .select('*')
        .eq('announcement_id', announcementId)
        .order('created_at', { ascending: false });

      if (listingsError) {
        console.error('Error fetching announcement listings:', listingsError);
        throw listingsError;
      }

      if (!listings || listings.length === 0) {
        return [];
      }

      // Get breeder profiles for all listings
      const breederIds = [...new Set(listings.map(listing => listing.breeder_id))];
      const { data: profiles, error: profilesError } = await supabase
        .from('profiles')
        .select('id, first_name, last_name, business_name, location')
        .in('id', breederIds);

      if (profilesError) {
        console.error('Error fetching breeder profiles:', profilesError);
        throw profilesError;
      }

      // Combine listings with their breeder profiles
      const listingsWithProfiles = listings.map(listing => {
        const profile = profiles?.find(p => p.id === listing.breeder_id);
        return {
          ...listing,
          profiles: profile || null
        };
      });

      return listingsWithProfiles;
    },
  });
};
